import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "slotDate",
    "slotTime",
    "hiddenInput",
    "slotDisplay",
    "container",
    "confirmedBadge",
    "changeButton",
    "selectionButtons",
  ];
  static values = {
    slots: Array,
    currentIndex: Number,
  };

  connect() {
    this.updateDisplay();
  }

  chooseAnother() {
    this.currentIndexValue =
      (this.currentIndexValue + 1) % this.slotsValue.length;
    this.updateDisplay();
  }

  changeSlot() {
    this.currentIndexValue =
      (this.currentIndexValue + 1) % this.slotsValue.length;
    this.updateDisplay();

    this.containerTarget.classList.remove("border-success");
    this.containerTarget.classList.add("border-primary");

    this.confirmedBadgeTarget.classList.add("hidden");
    this.changeButtonTarget.classList.add("hidden");
    this.selectionButtonsTarget.classList.remove("hidden");
    this.selectionButtonsTarget.classList.add("flex", "gap-4");
  }

  updateDisplay() {
    if (this.slotsValue.length === 0) {
      this.slotDateTarget.textContent = "No slots available";
      this.slotTimeTarget.textContent = "";
      this.hiddenInputTarget.value = "";
      return;
    }

    const currentSlot = this.slotsValue[this.currentIndexValue];

    this.slotDateTarget.textContent = currentSlot.date;
    this.slotTimeTarget.textContent = `Time: ${currentSlot.time}`;
    this.hiddenInputTarget.value = currentSlot.value;
  }
}
